module.exports = __webpack_public_path__ + "media/images/top/howto-03-6f87f7580cc56684bb5fca16dc17f428.svg";